export const loaderPath = {
  manufacturerRequests: "manufacturer-requests",
  processing: "processing",
  sendToDesigner: "send-to-designer",
  manufactureDetails: "manufacture-details",
  profitDistributions: "profit-distributions",
};

export const defaultRequestsFilterValues = {
  min_amount: "",
  max_amount: "",
  min_requested_on: "",
  max_requested_on: "",
  status: "",
};

export const requestsFilterFields = [
  {
    name: "created_at_min",
    type: "date",
    formLabel: "min-created-at",
    placeholder: "min-created-at",
    size: { xs: 12 },
  },
  {
    name: "created_at_max",
    type: "date",
    formLabel: "max-created-at",
    placeholder: "max-created-at",
    size: { xs: 12 },
  },
];
export const processingFilterFields = [
  {
    name: "created_at_min",
    type: "date",
    formLabel: "min-created-at",
    placeholder: "min-created-at",
    size: { xs: 12 },
  },
  {
    name: "created_at_max",
    type: "date",
    formLabel: "max-created-at",
    placeholder: "max-created-at",
    size: { xs: 12 },
  },
];

export const requestTableColumn = [
  { key: "manufacturer_name", label: "manufacturer" },
  { key: "business_name", label: "jeweler" },
  { key: "status", label: "status" },
  { key: "expected_completion", label: "expected-completion-days" },
  { key: "created_at", label: "created-at" },
  { key: "view", label: "view", align: "center" },
];

export const processingTableColumn = [
  { key: "manufacturer", label: "manufacturer" },
  { key: "business_name", label: "jeweler" },
  { key: "status", label: "status" },
  { key: "expected_completion", label: "expected-completion-days" },
  { key: "created_at", label: "created-at" },
  { key: "view", label: "view", align: "center" },
  { key: "action", label: "action" },
];

export const profitDistributionsColumn = [
  { key: "product_name", label: "product-name" },
  { key: "recipient_name", label: "recipient-name" },
  { key: "recipient_type", label: "recipient-type" },
  { key: "quantity", label: "quantity" },
  { key: "sale_price", label: "sale-price" },
  { key: "profit_amount", label: "profit-amount" },
  { key: "distributed_at", label: "distributed-at" },
  { key: "view", label: "view", align: "center" },
];

export const publishToMarketPlaceFields = [
  {
    name: "publish_date",
    formLabel: "publish-on",
    placeholder: "publish-on-placeholder",
    type: "date",
    registerOptions: {
      required: {
        value: true,
        message: "publish-on-required-error",
      },
    },
    size: { xs: 6 },
  },
  {
    name: "publish_time",
    formLabel: "publish-at",
    placeholder: "publish-at-placeholder",
    type: "time",
    registerOptions: {
      required: {
        value: true,
        message: "publish-time-required-error",
      },
    },
    size: { xs: 6 },
  },
];

export const profitDistributionFilterFields = [
  {
    name: "recipient_business_name",
    type: "text",
    formLabel: "recipient-name",
    placeholder: "recipient-name-placeholder",
    size: { xs: 12 },
  },
  {
    name: "created_at_min",
    type: "date",
    formLabel: "min-distributed-at",
    placeholder: "min-distributed-at",
    size: { xs: 12 },
  },
  {
    name: "created_at_max",
    type: "date",
    formLabel: "max-distributed-at",
    placeholder: "max-distributed-at",
    size: { xs: 12 },
  },
];
